import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { preferReducedMotion } from '../../styles/animation.js';
import { animationDuration } from '../../styles/variables.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { fRef } from '../../utils/React.js';
import { mainClass } from './Indicator.styles.js';

var getTransform = function getTransform(indicatorElement, activeElement, progress, isFullUnderline, isDirectionHorizontal) {
  var translate = 0;
  var scale = isFullUnderline ? 1 : 0;
  if (indicatorElement && activeElement) {
    var activeElementRect = activeElement.getBoundingClientRect();
    var indicatorParentElementRect = indicatorElement.parentElement.getBoundingClientRect();
    var styles = window.getComputedStyle(activeElement);
    var paddingTop = parseInt(styles.paddingTop, 10);
    var paddingRight = parseInt(styles.paddingRight, 10);
    var paddingBottom = parseInt(styles.paddingBottom, 10);
    var paddingLeft = parseInt(styles.paddingLeft, 10);
    translate = isDirectionHorizontal ? activeElementRect.left + paddingLeft - indicatorParentElementRect.left - indicatorElement.offsetLeft : activeElementRect.top + paddingTop - indicatorParentElementRect.top - indicatorElement.offsetTop;
    scale = isDirectionHorizontal ? (activeElementRect.width - paddingLeft - paddingRight) / indicatorElement.offsetWidth : (activeElementRect.height - paddingTop - paddingBottom) / indicatorElement.offsetHeight;
  }
  if (progress) {
    scale = progress / 100.0;
  }
  return {
    translate: translate,
    scale: scale
  };
};
var IndicatorPresentation = fRef(function (props) {
  var _cleanupClassObject;
  var className = props.className,
    noAnimation = props.noAnimation,
    ref = props.ref,
    scale = props.scale,
    direction = props.direction,
    translateOrthogonal = props.translateOrthogonal,
    fadeAnimation = props.fadeAnimation;
  var translate = props.translate ? "".concat(props.translate, "px") : "0";
  var reduceAnimation = preferReducedMotion();
  return /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, mainClass, true), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__").concat(direction), true), _defineProperty(_cleanupClassObject, "animationFade__".concat(direction), fadeAnimation), _cleanupClassObject)),
    style: {
      transition: noAnimation && reduceAnimation ? "unset" : "transform ".concat(animationDuration.standard),
      transform: direction === "horizontal" ? "translateX(".concat(translate, ") translateY(").concat(translateOrthogonal, "px) scaleX(").concat(scale, ")") : "translateY(".concat(translate, ") translateX(").concat(translateOrthogonal, "px) scaleY(").concat(scale, ")")
    },
    ref: ref
  });
});
IndicatorPresentation.displayName = "IndicatorPresentation";

export { IndicatorPresentation, getTransform };
